let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;

  setTimeout(function () {
    // loadScript("//www.wearcomet.com/cdn/shop/t/253/assets/cart-drawer.js?v=68401610320305176801783066234");
    // loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-list-social.css?v=52211663153726659061783066236");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-cart.css?v=61086454150987525971783066234");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-cart-drawer.css?v=15566466097704326981783066232");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-totals.css?v=86168756436424464851783066233");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-discounts.css?v=164788277903287711551787990254");
    // loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-loading-overlay.css?v=167310470843593579841783066236");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-cart-items.css?v=138827669520066067571787979383");
    
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/section-footer.css?v=171161867995400310821783066233");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-newsletter.css?v=103472482056003053551783066235");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-list-menu.css?v=151968516119678728991783066234");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-list-payment.css?v=69253961410771838501783066235");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-list-social.css?v=52211663153726659061783066236");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/footer.css?v=87833187280690901731783066488");
    

    //js
    loadScript("//www.wearcomet.com/cdn/shop/t/253/assets/cart-notification.js?v=160453272920806432391783066235");
    // search-form.js already loaded globally via header.liquid
    loadScript("//www.wearcomet.com/cdn/shop/t/253/assets/cart-drawer-script.js?v=24308693613533450291783066233");
    loadScript("//www.wearcomet.com/cdn/shop/t/253/assets/quick-add-to-cart.js?v=149215956464844627301786110209");
    //endjs

      document.querySelectorAll('.placeholder-slk-prnt')?.forEach(el => {
        el.style.opacity = '0';
      });

      document.querySelectorAll('.onrendered-slider-prnt')?.forEach(el => {
        el.style.opacity = '1';
      });
  
  }, 10);

  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mousemove', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

if (window.scrollY >= 400) {
  loadScripts();
} else {
  document.addEventListener('mousemove', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts);
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}